import * as Constants from '@/lib/constants'
import storage from '@/lib/storage'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'

/**
 * VuetifyのI18nのWrapperです。
 *
 * Vuetifyの標準ではNamed Formattingができないので、それに対応させています。
 * mustacheの中では {{ $tt('message', {msg: 'Hello'}) }} のように使えます。
 * 通常のscript中では i18n.tt('message', {msg: 'Hello'}) のように使えます。
 */
class I18n {
  /**
   * AgriBus-NAVIで定義されているものと同じリソースキーで呼び出します。
   * （locale.ts内で名前空間がnaviのもの）
   */
  navi(label, params) {
    return this.tt('navi.' + label, params)
  }

  tt(label, params) {
    let message = vuetify.framework.lang.t('$vuetify.' + label)
    if (params) {
      Object.keys(params).forEach(key => {
        const regex = new RegExp('{' + key + '}', 'g')
        message = message.replace(regex, params[key])
      })
    }
    return message
  }

  setUserLang(userInfo) {
    let lang = userInfo.language
    this.setUserLangByLanguage(lang)
  }

  /**
   * 言語をセットしますが、LANG_JA、LANG_PT
   * 以外の値がセットされようとした場合、
   * 強制的にLANG_ENになります。
   */
  setUserLangByLanguage(lang) {
    let userLang = Constants.LANG_DEFAULT
    if (Constants.LANG_DE === lang) {
      userLang = Constants.LANG_DE
    } else if (Constants.LANG_ES === lang) {
      userLang = Constants.LANG_ES
    } else if (Constants.LANG_JA === lang) {
      userLang = Constants.LANG_JA
    } else if (Constants.LANG_PT === lang) {
      userLang = Constants.LANG_PT
    } else if (Constants.LANG_PL === lang) {
      userLang = Constants.LANG_PL
    } else if (Constants.LANG_RU === lang) {
      userLang = Constants.LANG_RU
    } else if (Constants.LANG_TH === lang) {
      userLang = Constants.LANG_TH
    }
    vuetify.framework.lang.current = userLang
    storage.saveUserLanguage(userLang)
  }

  getUserLang() {
    return storage.getUserLang()
  }

  isShowSpecifiedCommercialTransactionLaw(lang) {
    if (lang === Constants.LANG_JA) {
      return true
    }
    return false
  }
}

const i18n = new I18n()

Vue.prototype.$tt = function(label, params) {
  return i18n.tt(label, params)
}

export default i18n
